import React from 'react'
import styled from 'styled-components'

interface ProgressFillProps {
  progress: number
}

const ProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%; /* adjust as needed */
  margin-bottom: 30px;
`

const ProgressBar = styled.div`
  flex: 1;
  height: 10px; /* thin bar */
  background-color: #ddd;
  border-radius: 5px;
  overflow: hidden;
`

const ProgressFill = styled.div<ProgressFillProps>`
  height: 100%;
  width: ${({ progress }) => progress}%;
  background-color: #6b8e23; /* olive green */
  border-radius: 5px;
  transition: width 0.3s ease;
`

const ProgressText = styled.span`
  font-size: 14px;
  color: #333;
`
interface props {
  current: number
  total: number
}

const Progress = ({ current, total }: props) => {
  const progressPercent = (current / total) * 100

  return (
    <ProgressWrapper>
      <ProgressBar>
        <ProgressFill progress={progressPercent} />
      </ProgressBar>
      <ProgressText>
        {current} / {total}
      </ProgressText>
    </ProgressWrapper>
  )
}

export default Progress
